import React, { PureComponent } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { scaleLinear } from "d3-scale";
import usGeography from "./us-10m.json";
import { Tooltip } from "react-tooltip";
import Loader from "./../Loader/Loader.js";
import { selectFormat } from "./../Utils/Utils.js";

const cityScale = scaleLinear().domain([0, 47380]).range([1.5, 30]);

class LeeSubscriberLocations extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data,
    opts: {
      type: "other",
    },
  });

  render() {
    const { loading, data } = this.props;
    data.data.forEach((d) => (d.coordinates = [d.longitude, d.latitude]));
    const max = Math.max(...data.data.map((d) => d.subscribers)) || 1;
    cityScale.domain([0, max]);

    if (loading) {
      return <Loader minHeight={550} col={"col-12"} />;
    }

    return (
      <>
        <ComposableMap
          projectionConfig={{ scale: 1000 }}
          width={980}
          height={550}
          projection="geoAlbersUsa"
          style={{
            width: "100%",
            height: "auto",
          }}
        >
          <Geographies geography={usGeography}>
            {({ geographies }) =>
              geographies.map((geography, i) => (
                <Geography
                  key={i}
                  geography={geography}
                  style={{
                    default: {
                      fill: "#ECEFF1",
                      stroke: "#607D8B",
                      strokeWidth: 0.75,
                      outline: "none",
                    },
                    hover: {
                      fill: "#ECEFF1",
                      stroke: "#607D8B",
                      strokeWidth: 0.75,
                      outline: "none",
                    },
                  }}
                />
              ))
            }
          </Geographies>

          {data.data.map((marker, i) => (
            <Marker key={i} coordinates={marker.coordinates}>
              <circle
                cx={0}
                cy={0}
                r={cityScale(marker.subscribers)}
                fill="blueviolet"
                stroke="#607D8B"
                strokeWidth="1"
                strokeOpacity="0.8"
                data-tooltip-id="tooltip"
                data-tooltip-html={`${marker.name}:  ${selectFormat(
                  "number",
                  marker.subscribers
                )} `}
              />
            </Marker>
          ))}
        </ComposableMap>
        <Tooltip id="tooltip" className="title-tooltip" />
      </>
    );
  }
}

export default LeeSubscriberLocations;
